import PrintSectionAsPDF, { getSectionSummaryId } from "./PrintSectionAsPDF";

export default PrintSectionAsPDF;

export { getSectionSummaryId };
